// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/* tslint:disable */
/**
 * The setting editor tracker token.
 */
export const ISettingEditorTracker = new Token('@jupyterlab/settingeditor:ISettingEditorTracker');
/* tslint:enable */
/**
 * The setting editor tracker token.
 */
export const IJSONSettingEditorTracker = new Token('@jupyterlab/settingeditor:IJSONSettingEditorTracker');
//# sourceMappingURL=tokens.js.map